// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__2jlgg","items":"style_items__2Epvd","isParagraphs":"style_isParagraphs__1TcSZ","gridded":"style_gridded__3VRht"};